import { useState, useEffect } from 'react'
import { Button } from '@/components/ui/button.jsx'
import { Icon } from '@iconify/react'
import { Drawer, DrawerContent, DrawerClose } from '@/components/ui/drawer'
import ChatPage from '@/pages/dashboard/library/ChatPage.jsx'
import { cn } from '@/lib/utils'
import { useCreativeAiChat } from '@/context-state/CreativeAiChatContext.jsx'

export function CreativeAiChatDrawer() {
    const {
        isDrawerOpen,
        closeDrawer,
        chatId,
        setChatId,
        messages,
        setMessages,
        isFirstMessage,
        setIsFirstMessage,
        isLoading,
        setIsLoading,
        isTyping,
        setIsTyping,
        clearChat,
        pendingQuestion,
        setPendingQuestion,
        creativeContext,
        setCreativeContext
    } = useCreativeAiChat()
    const [isFullWidth, setIsFullWidth] = useState(false)
    const [hasBeenOpened, setHasBeenOpened] = useState(false)

    // Track when drawer opens for the first time
    useEffect(() => {
        if (isDrawerOpen && !hasBeenOpened) {
            setHasBeenOpened(true)
        }
    }, [isDrawerOpen, hasBeenOpened])

    const handleOpenChange = (newOpen) => {
        if (!newOpen) {
            closeDrawer()
        }
    }

    return (
        <Drawer direction="right" open={isDrawerOpen} onOpenChange={handleOpenChange}>
            <DrawerContent
                direction="right"
                className={cn(
                    "bg-background/95 backdrop-blur-xl focus:outline-none focus-visible:outline-none",
                    isFullWidth ? "!max-w-full" : "max-w-3xl"
                )}
            >
                <div className="h-full w-full flex flex-col relative bg-transparent">
                    {/* Chat content - persist state */}
                    {hasBeenOpened && (
                        <div className={isDrawerOpen ? 'block h-full' : 'hidden'}>
                            <ChatPage
                                externalChatId={chatId}
                                externalMessages={messages}
                                externalSetMessages={setMessages}
                                externalIsFirstMessage={isFirstMessage}
                                externalSetIsFirstMessage={setIsFirstMessage}
                                externalSetChatId={setChatId}
                                externalClearChat={clearChat}
                                externalIsLoading={isLoading}
                                externalSetIsLoading={setIsLoading}
                                externalIsTyping={isTyping}
                                externalSetIsTyping={setIsTyping}
                                externalPendingQuestion={pendingQuestion}
                                externalSetPendingQuestion={setPendingQuestion}
                                externalCreativeContext={creativeContext}
                                externalSetCreativeContext={setCreativeContext}
                            />
                        </div>
                    )}
                </div>
            </DrawerContent>
        </Drawer>
    )
}

export default CreativeAiChatDrawer
